import React, { Component, Fragment } from 'react';
import CloseActionButton from '../common/CloseActionButton';
import MyDepartmentDetailsForm from './MyDepartmentDetailsForm';

class MyDepartmentEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        name: this.props.department.name,
        timezone: this.props.department.timezone,
      },
    };
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <MyDepartmentDetailsForm
          initialValues={this.state.initialValues}
          onSave={formData => this.props.onSave(formData)}
        />
      </Fragment>
    );
  }
}


export default MyDepartmentEdit;
